module.exports = __webpack_public_path__ + "assets/img/aiwriter-bus3.cd96dca3.png";